import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * A custom element that displays product specifications metafield.
 * Updates automatically when variants change, with fallback to product-level metafields.
 */
class ProductSpecifications extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateSpecifications);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateSpecifications);
  }

  /**
   * Updates the specifications display when variant changes.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateSpecifications = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newSpecifications = event.detail.data.html.querySelector('product-specifications');

    if (!newSpecifications) {
      // No specifications for this variant - hide the current block
      this.style.display = 'none';
      return;
    }

    // Show the block if it was hidden
    this.style.display = 'block';

    // Update the content
    morph(this, newSpecifications, { childrenOnly: true });
  };
}

if (!customElements.get('product-specifications')) {
  customElements.define('product-specifications', ProductSpecifications);
}
